












































































































import { Component, Vue } from "vue-property-decorator";
import { Logger } from 'aws-amplify';
import { getModule } from "vuex-module-decorators";
import Users from "@/store/modules/Users";
import { Urls } from "@/Urls";

// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("UserMembership");

const users = getModule(Users)
@Component({
    components: {},
})
export default class UserMembership extends Vue {
    private readonly Urls = Urls;
    private processing = false;

    get membership() {
        return users.currentUserMembership;
    }

    get originalPrice() {
        return this.membership.costDetails.amount;
    }

    get price() {
        let price = this.membership.costDetails.amount;
        let coupon = this.coupon;
        if (coupon) {
            if (coupon.percentOff) {
                return price * (1 - coupon.percentOff / 100);
            } else if (coupon.amountOff) {
                return price - coupon.amountOff
            }
        }
        return price;
    }

    get coupon() {
        if (this.membership && this.membership.costDetails) {
            return this.membership.costDetails.coupon;
        }
    }

    get isCancelled() {
        return this.membership.subscriptionEndTimestamp != null
    }

    private cancelMembership() {
        this.processing = true;
        users.cancelMembership()
            .then(() => {
                this.processing = false;
                users.fetchCurrentUserData();
            })
    }

    private resumeMembership() {
        this.processing = true;
        users.resumeMembership()
            .then(() => {
                this.processing = false;
                users.fetchCurrentUserData();
            })
    }

}
